import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import type { Organization } from '@elecmap/api/src/ram.d'
import { changeOrganization } from '@elecmap/api/src/ram'
import userStore from './user'
import { useSpaceStore } from './space'
import { OrgAccountSeatType, SeatVersion } from '@elecmap/api/src/ram/seat.d'

export const useOrganization = defineStore('organization', () => {
  let defaultOrganization = []
  let defaultOrganizationId
  let defaultIsPlatform = false
  if (localStorage.getItem('organizationList')) {
    defaultOrganization = JSON.parse(localStorage.getItem('organizationList') || '[]')
  }

  if (localStorage.getItem('organizationId')) {
    defaultOrganizationId = JSON.parse(localStorage.getItem('organizationId') || '0')
  }

  if (localStorage.getItem('isPlatformUser')) {
    defaultIsPlatform = JSON.parse(localStorage.getItem('isPlatformUser') || 'false')
  }

  const organization = ref<Organization[]>(defaultOrganization)
  const organizationId = ref<number>(defaultOrganizationId)
  const isPlatformUser = ref(defaultIsPlatform)
  function setOrganization(list: Organization[]) {
    organization.value = list
    localStorage.setItem('organizationList', JSON.stringify(list))
  }

  const setCurrentOrganizationId = (id: number, organizationType?: string) => {
    if (id) {
      organizationId.value = id
      localStorage.setItem('organizationId', String(id))

      const isPlatform = organizationType === 'platform'
      isPlatformUser.value = isPlatform
      localStorage.setItem('isPlatformUser', JSON.stringify(isPlatform))
    } else {
      isPlatformUser.value = false
      localStorage.setItem('isPlatformUser', JSON.stringify(false))
      localStorage.removeItem('organizationId')
      setOrganization([])
    }

    userStore().userInfo.organizationId = id
    const space = useSpaceStore()
    space.navs = []
  }

  const currentOrganization = computed({
    get: () => organization.value.find(o => o.id === organizationId.value),
    set: v => {
      const index = organization.value.findIndex(o => o.id === organizationId.value)
      organization.value[index] = v
    },
  })

  function resetToPersonalOrg() {
    organizationId.value = organization.value[0].id
    return changeOrganization(organizationId.value)
  }

  return {
    organization,
    setOrganization,
    organizationId,
    setCurrentOrganizationId,
    isPlatformUser,
    currentOrganization,
    resetToPersonalOrg,
  }
})

export function getAccountTypeDesc(o: Organization) {
  if (!o) return '免费版'
    if (o.seatVersion === SeatVersion.Pro) {
    return '专业版'
  }
  if (o.seatVersion === SeatVersion.CoCreation) {
    return '共创版'
  }
  return '免费版'
}

export function getAccountTypeStyle(o: Organization) {
  if (!o) return null
  if (o.seatVersion === SeatVersion.Pro) {
    return { color: '#42B751', backgroundColor: 'rgb(66 183 81 / 15%)' }
  }
  if (o.seatVersion === SeatVersion.CoCreation) {
    return { color: '#268FEB', backgroundColor: 'rgb(38 143 235 / 15%)' }
  }
  return null
}
